<script>
    import {onMount} from 'svelte';
    import {Input, InputScheme, FileSelect, RadioGroup, Radio, Select, Button} from '../components/ui';
    import {Image} from '../components/display';
    import {productMainTypes, productSubTypes} from '../definitions/Lists';

    import {getByAttr} from '../helper/ListExtensions';
    import {getWebsiteInfos} from '../helper/PostHelper';

    export let model;

    let setBrandDataManually = true;

    let targetGroups = [
        { value: 1, text: `B2B` },
		{ value: 2, text: `B2C` }
    ]

    onMount(()=>{
        if(model.id == null)
            typeChange();
    })
    function typeChange(){
        //TODO Check if Name was changed manually -> If yes, return
        model.name = `My ${getByAttr(productSubTypes, 'Value', model.subType).Text} ${getByAttr(productMainTypes, 'Value', model.mainType).Text}`
    }

    function getWebsiteData(){
        if(model.website == null)
            return;

        if(model.website.length < 2)
            return;

        alert('brandr website currently down 08.04.2020. Please set data manually!');
        setBrandDataManually = true;
        /* brandr website currently down 08.04.2020*/
        //getWebsiteInfos(model.website).then((res)=>{
           // model.brandrApi = res;    
                    //TODO set logo and main color

        //})
    }
</script>
<div>
     <div class="mt-4 mb-4 flex flex-row">
        <Select bind:model={model.mainType} list={productMainTypes} on:change={typeChange} class="w-1/2 col-span-6 sm:col-span-3" label="What's your offer"/>
        <Select bind:model={model.subType} list={productSubTypes} on:change={typeChange} class="w-1/2 col-span-6 sm:col-span-3" label="What's your offer"/>
     </div>

    <div class="mt-4 mb-4 flex flex-row">
        <Input bind:model={model.name} class="w-1/2 sm:col-span-3" label="Name"/>
        <Input bind:model={model.category} class="w-1/2 sm:col-span-3" label="Category"/>
     </div>
    <div class="mt-4 mb-4 flex flex-row items-end">
        <InputScheme bind:model={model.website} class="w-1/2 sm:col-span-3" scheme="https://" label="Website"/>
        <Button on:submit={()=>{getWebsiteData()}} raised={true}>get website data</Button>
        <Button on:submit={()=>{setBrandDataManually = true}}>or set data manually</Button>
     </div>
     <!-- <div class="mt-4 mb-4">
     <RadioGroup class="flex flex-row">
      {#each targetGroups as item}
        <Radio value={item.value} bind:group={model.targetGroup} class="mr-4">
            {item.text}
        </Radio>
        {/each}
     </RadioGroup>
    </div> -->
    {#if setBrandDataManually}
    <div class="mt-4 mb-4">
        <FileSelect bind:model={model.logo} class="sm:col-span-6" label="Logo plz"/>
    </div>
     <div class="mt-4 mb-4 flex flex-row">
        <div style="width:32px; height:32px; margin-top: 27px; margin-right:16px; background-color:{model.mainColor}"></div>
        <InputScheme bind:model={model.mainColor} class="w-1/4" scheme="#" label="Main color"/>
    </div>
    {/if}
</div>